import { parseIsoDate, toIsoDate } from "@/features/events/eventDate";

/**
 * Default date range for the Finances page: 6 calendar months back through
 * today. Reuses events/eventDate's local-safe ISO helpers (never
 * `new Date("YYYY-MM-DD")`, which parses as UTC and can shift a day) so this
 * range math shares the one DST/month-boundary-safe implementation instead
 * of a second copy.
 */
export function defaultFinanceRange(today: Date = new Date()): { from: string; to: string } {
  const from = new Date(today.getFullYear(), today.getMonth() - 5, 1);
  return { from: toIsoDate(from), to: toIsoDate(today) };
}

/** "YYYY-MM" -> "Jan '26" — mirrors DashboardPage's formatMonthLabel. */
export function formatMonthLabel(month: string): string {
  const [y, m] = month.split("-").map(Number);
  if (!y || !m) return month;
  return new Date(y, m - 1, 1).toLocaleDateString(undefined, { month: "short", year: "2-digit" });
}

export { parseIsoDate, toIsoDate };
